(function () {
  var track = document.getElementById('wkTrack');
  if (!track) return;

  var prev = document.getElementById('wkPrev');
  var next = document.getElementById('wkNext'); 
  var dots = document.getElementById('wkDots');
  var tabs = [].slice.call(document.querySelectorAll('#wkTabs .wk-tab'));

  var isGrid = track.classList.contains('wk-grid');
  var GAP = 24;
  var originals = [].slice.call(track.querySelectorAll('.wk-card'));
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  var shown = originals.slice();
  var cycle = 0, pages = 1, timer = null, target = null, idle = 0;
  var down = false, moved = false, startX = 0, startLeft = 0;
  var TICK = 30;
  var HOLD = Math.round(4500 / TICK);

  function normalizeTag(value) {
    return (value || "").toString().trim().toLowerCase();
  }

  /* Compare a menu link's path to the current page exactly. The old endsWith
     check matched partial paths and failed on absolute hrefs. */
  function samePath(link, currentPath) {
    var href = link.getAttribute("href");
    if (!href || href.charAt(0) === "#") return false;
    var path;
    try { path = new URL(href, window.location.origin).pathname; } catch (e) { return false; }
    path = path.replace(/\/+$/, "");
    return path !== "" && path === currentPath;
  }

  /* Returns:
       "tag-a,tag-b"  the current page's menu link carries tags
       ""             the current page's menu link has data-portfolio-tag but it
                      is empty -> all cards are hidden
       null           no menu link for this page carries the attribute -> all
                      cards are hidden */
  function getActiveMenuTag() {
    var currentPath = window.location.pathname.replace(/\/+$/, "");
    function isCurrent(link) {
      return link.getAttribute("aria-current") === "page" || samePath(link, currentPath);
    }

    /* Only the page's own link counts. A sub-link without the attribute does
       NOT inherit its group heading's tag, so the section stays hidden. */
    var found = false;
    var tagged = document.querySelectorAll("a[data-portfolio-tag]");
    for (var i = 0; i < tagged.length; i++) {
      if (!isCurrent(tagged[i])) continue;
      found = true;
      var tag = tagged[i].getAttribute("data-portfolio-tag").trim();
      if (tag) return normalizeTag(tag); 
    }

    return found ? "" : null;
  }

  /* Only sections that opt in (data-menu-filter on #wkTrack, set in
     work-grid.liquid) filter by the header tag. Others, like the homepage
     n-work-grid, always show every card. */
  var menuFilter = track.hasAttribute('data-menu-filter'); 

  function cardMatchesMenuTag(card, menuTag) {
    if (!menuFilter) return true;
    if (!menuTag) return false;          // no tagged link for this page, or empty tag: nothing matches
    var tagsName = card.getAttribute("data-tags-name") || "";
    var cardTagsArray = tagsName.split(",").map(function(t) { return normalizeTag(t); }).filter(Boolean);
    var menuTagsArray = menuTag.split(",").map(function(t) { return normalizeTag(t); }).filter(Boolean);
    var isMatch = menuTagsArray.some(function(mTag) {
      return cardTagsArray.includes(mTag);
    });
    return isMatch;
  }
 
  function cardMatchesTabFilter(card, tabFilter) {
    if (tabFilter === 'all') return true;
    if (card.getAttribute('data-type') === tabFilter) return true;
    var tagsSpace = card.getAttribute('data-tags');
    if (tagsSpace && (' ' + tagsSpace + ' ').indexOf(' ' + tabFilter + ' ') !== -1) return true;
    var tagsName = card.getAttribute('data-tags-name');
    if (tagsName) {
      var tagsArray = tagsName.split(',').map(function(t) { return normalizeTag(t); });
      if (tagsArray.indexOf(normalizeTag(tabFilter)) !== -1) return true;
    }
    return false;
  }

  /* Cards only show for this page's mega-menu data-portfolio-tag. With no tagged
     link for this page or an empty tag, every card is hidden (the section stays).
     Tabs with no cards for this page's tag would lead to an empty view. */
  var pageMenuTag = getActiveMenuTag();
  tabs = tabs.filter(function (tab) {
    var filter = tab.getAttribute('data-filter');
    if (filter === 'all') return true;
    var has = originals.some(function (c) {
      return cardMatchesMenuTag(c, pageMenuTag) && cardMatchesTabFilter(c, filter);
    });
    if (!has) tab.hidden = true;
    return has;
  });

  if (isGrid) {
    function applyGridFilter() {
      var activeMenuTag = getActiveMenuTag();
      var activeTabBtn = document.querySelector('#wkTabs .wk-tab.is-active');
      var activeTabFilter = activeTabBtn ? activeTabBtn.getAttribute('data-filter') : 'all';

      originals.forEach(function(card) {
        var matchesTab = (activeTabFilter === 'all') || cardMatchesTabFilter(card, activeTabFilter);
        var matchesMenu = cardMatchesMenuTag(card, activeMenuTag);
        if (matchesTab && matchesMenu) {
          card.classList.remove('hidden');
          card.hidden = false;
        } else {
          card.classList.add('hidden');
          card.hidden = true;
        }
      });

      if (tabs) {
        tabs.forEach(function(tab) {
          var filter = tab.getAttribute('data-filter');
          var count = 0;
          originals.forEach(function(card) {
            if (cardMatchesMenuTag(card, activeMenuTag) && cardMatchesTabFilter(card, filter)) count++;
          });
          var span = tab.querySelector('span');
          if (span) span.textContent = count;
        });
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        applyGridFilter();
      });
    });

    setTimeout(applyGridFilter, 100);
    return; 
  }

  /* Cached geometry — see the matching note in sliders.js. cardWidth and
     frameWidth were measured from the DOM on every tick via sync() -> stride()
     -> perView(), and isRTL ran getComputedStyle on every scroll write. At the
     33 Hz creep that is several forced layouts a tick; Lighthouse attributed
     2,210 ms of mobile CPU to this file. None of it changes between frames. */
  var mCard = null, mFrame = null;
  function invalidateMeasures() { mCard = mFrame = null; }

  function cardWidth() {
    if (mCard === null) {
      var c = track.querySelector('.wk-card');
      mCard = c ? c.getBoundingClientRect().width : 0;
    }
    return mCard;
  }

  function frameWidth() {
    if (mFrame === null) {
      var c = track.closest('.container');
      mFrame = c ? c.clientWidth : track.clientWidth;
    }
    return mFrame;
  }

  function perView() {
    var w = cardWidth();
    if (!w) return 1;
    return Math.max(1, Math.floor((frameWidth() + GAP) / (w + GAP)));
  }

  function stride() { return perView() * (cardWidth() + GAP); }
  var rtl = getComputedStyle(track).direction === 'rtl';
  function sx() { return Math.abs(track.scrollLeft); }
  function setSx(v) { track.scrollLeft = rtl ? -v : v; }
  function addSx(d) { setSx(sx() + d); }

  function updateCounts() {
    if (!tabs) return;
    var activeTabBtn = tabs.find(function(t) { return t.classList.contains('is-active'); });
    var activeTabFilter = activeTabBtn ? activeTabBtn.getAttribute('data-filter') : 'all';
    var activeMenuTag = getActiveMenuTag();

    tabs.forEach(function(tab) {
      var filter = tab.getAttribute('data-filter');
      var count = 0;
      originals.forEach(function(card) {
        if (cardMatchesMenuTag(card, activeMenuTag) && cardMatchesTabFilter(card, filter)) count++;
      });
      var span = tab.querySelector('span');
      if (span) span.textContent = count;
    });
  }

  function build(filter) {
    var activeMenuTag = getActiveMenuTag();
    shown = originals.filter(function (c) {
      return ((filter === 'all') || cardMatchesTabFilter(c, filter)) && cardMatchesMenuTag(c, activeMenuTag);
    });

    while (track.firstChild) track.removeChild(track.firstChild);
    shown.forEach(function (c) { track.appendChild(c); });

    // ✅ FIXED: Agar 2 ya us se kam slides hon to slider, dots sab hide ho jayenge.
    if (shown.length <= 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (dots) {
        dots.style.display = 'none';
        dots.innerHTML = ''; // Clear dots to be safe
      }
      if (timer) { clearInterval(timer); timer = null; }
      cycle = 0;
      setSx(0);
      target = null;
      updateCounts();
      return;
    }

    if (prev) prev.style.display = '';
    if (next) next.style.display = '';
    if (dots) dots.style.display = '';

    cycle = shown.length * (cardWidth() + GAP);
    if (cycle > 0) {
      var need = cycle * 2 + track.clientWidth;
      var total = cycle;
      while (total < need) {
        shown.forEach(function (c) {
          var clone = c.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('tabindex', '-1');
          // Links and buttons inside a hidden copy must not be reachable with Tab either.
          Array.prototype.forEach.call(clone.querySelectorAll('a[href], button, input, select, textarea, iframe, summary, [tabindex]'), function (n) {
            n.setAttribute('tabindex', '-1');
          });
          track.appendChild(clone);
        });
        total += cycle;
      }
    }

    setSx(0);
    target = null;
    buildDots();
    sync();
    updateCounts();
  }

  function loop() {
    if (cycle <= 0) return;
    if (sx() >= cycle * 2) {
      addSx(-cycle);
      if (target !== null) target -= cycle;
    }
  }

  function buildDots() {
    if (!dots) return;

    pages = Math.max(1, Math.ceil(shown.length / perView()));
    dots.innerHTML = '';

    // Kyun ke upar <= 2 par return ho chuka hai, yahan dots hamesha show honge
    dots.style.display = 'flex';
    for (var i = 0; i < pages; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'slider-dot';
      d.setAttribute('data-i', i);
      d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dots.appendChild(d);
    }
    /* Clicks are delegated to #wkDots (bound once, below) instead of one
       listener per dot: the dots are rebuilt on every filter change and every
       resize, which used to stack duplicate handlers. */
    setActiveDot(pageFromPos(target !== null ? target : sx()));
  }

  /* Which page is on screen. The position can sit anywhere inside the cloned
     loop, so fold it back into one cycle, round to the nearest page and wrap.
     The result is always 0..pages-1, so exactly one dot can ever be active.
     (The old maths could return `pages` itself, lighting the wrong dot, and
     mishandled the negative scrollLeft used in RTL.) */
  function pageFromPos(pos) {
    if (cycle <= 0) return 0;
    var s = stride();
    if (!s) return 0;
    var within = ((pos % cycle) + cycle) % cycle;
    return ((Math.round(within / s) % pages) + pages) % pages;
  }

  /* Keep the active dot inside the strip. There is one dot per page, so the row
     is often wider than the section (72 dots, ~750px, on a phone). Once the
     active dot scrolled past the edge it was clipped, which looked exactly like
     no dot being active at all. Does nothing when the whole row fits. */
  function keepDotInView(el) {
    if (!dots || !el) return;
    var max = dots.scrollWidth - dots.clientWidth;
    if (max <= 1) return;
    var strip = dots.getBoundingClientRect();
    var dot = el.getBoundingClientRect();
    var want = dots.scrollLeft + (dot.left - strip.left) - (dots.clientWidth - dot.width) / 2;
    want = rtl ? Math.min(0, Math.max(-max, want)) : Math.max(0, Math.min(max, want));
    if (Math.abs(dots.scrollLeft - want) < 1) return;
    if (dots.scrollTo) dots.scrollTo({ left: want, behavior: calm.matches ? 'auto' : 'smooth' });
    else dots.scrollLeft = want;
  }

  function setActiveDot(idx) {
    if (!dots) return;
    var kids = dots.children;
    for (var j = 0; j < kids.length; j++) {
      var on = j === idx;
      // Only write when the state actually changes: sync() runs on every scroll
      // event and on every animation tick.
      if (kids[j].classList.contains('active') === on) continue;
      kids[j].classList.toggle('active', on);
      if (on) {
        kids[j].setAttribute('aria-current', 'true');
        keepDotInView(kids[j]);
      } else {
        kids[j].removeAttribute('aria-current');
      }
    }
  }

  /* While a glide is running the dots follow its destination, so Next/Prev and
     a dot click light the right dot immediately; otherwise they follow the real
     scroll position, which covers dragging, touch/wheel scrolling and the auto
     creep. One code path, so the dots cannot disagree with the slides. */
  function sync() {
    if (!dots || !dots.children.length || cycle <= 0) return;
    setActiveDot(pageFromPos(target !== null ? target : sx()));
  }

  function glideTo(to) {
    if (calm.matches) { setSx(to); loop(); sync(); return; }
    target = to;
    sync();
  }

  if (dots) {
    dots.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.slider-dot') : null;
      if (!btn || !dots.contains(btn)) return;
      var idx = parseInt(btn.getAttribute('data-i'), 10);
      if (isNaN(idx)) return;
      var base = cycle > 0 ? Math.floor(sx() / cycle) * cycle : 0;
      glideTo(base + idx * stride());
    });
  }

  function step(dir) {
    var amount = Math.max(cardWidth() + GAP, track.clientWidth * 0.6);
    var from = target !== null ? target : sx();
    if (dir < 0 && from < amount) { addSx(cycle); from += cycle; }
    glideTo(from + dir * amount);
  }

  function tick() {
    if (down) return;
    if (target !== null) {
      var d = target - sx();
      if (Math.abs(d) < 1.5) { setSx(target); target = null; idle = HOLD; }
      else { addSx(d * 0.16); }
      loop(); sync(); return;
    }
    if (idle > 0) { idle--; return; }
    if (hovered) return;
    addSx(1); loop();
  }

  /* :hover was matched on every tick, forcing a style recalc; two listeners
     carry the same state for nothing. And the creep ran at 33 Hz for the life of
     the page even with the strip far off screen — now only while it is visible
     and the tab is in the foreground. */
  var hovered = false;
  track.addEventListener('mouseenter', function () { hovered = true; });
  track.addEventListener('mouseleave', function () { hovered = false; });

  var onScreen = true;
  function refreshAuto() {
    if (onScreen && !document.hidden) startAuto(); else stopAuto();
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      refreshAuto();
    }, { threshold: 0 }).observe(track);
  }
  document.addEventListener('visibilitychange', refreshAuto);

  function startAuto() {
    if (timer || calm.matches || cycle <= 0) return;
    timer = setInterval(tick, TICK);
  }

  function stopAuto() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });

  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
  });

  track.addEventListener('scroll', function () { loop(); sync(); }, { passive: true });

  track.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    down = true; moved = false; startX = e.pageX; startLeft = sx(); target = null;
  });
  
  window.addEventListener('mousemove', function (e) {
    if (!down) return;
    var dx = (e.pageX - startX) * (rtl ? -1 : 1);
    if (Math.abs(dx) > 6) { moved = true; track.classList.add('dragging'); }
    if (moved) {
      e.preventDefault();
      var left = startLeft - dx;
      if (cycle > 0) {
        while (left < 0) left += cycle;
        while (left >= cycle * 2) left -= cycle;
      }
      setSx(left);
      sync();
    }
  });
  
  window.addEventListener('mouseup', function () {
    if (!down) return;
    down = false; idle = HOLD;
    setTimeout(function () { track.classList.remove('dragging'); moved = false; }, 50);
  });
  
  track.addEventListener('click', function (e) {
    if (moved || track.classList.contains('dragging')) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      built = true;
      invalidateMeasures();
      build(tab.getAttribute('data-filter'));
      idle = HOLD;
      refreshAuto();
    }); 
  });

  var rt = null;
  window.addEventListener('resize', function () {
    invalidateMeasures();
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (!built) return;
      invalidateMeasures();
      rtl = getComputedStyle(track).direction === 'rtl';
      var active = document.querySelector('#wkTabs .wk-tab.is-active');
      build(active ? active.getAttribute('data-filter') : 'all');
      refreshAuto();
    }, 200);
  });

  /* The first build (filter + clone the cards for the seamless loop) runs when
     the strip comes within ~600px of the viewport instead of 100ms after load.
     Cloning and measuring the cards during load produced the forced reflows and
     most of the extra DOM Lighthouse reported; the section is below the fold,
     so the visitor never sees the difference. */
  var built = false;
  function firstBuild() {
    if (built) return;
    built = true;
    invalidateMeasures();
    var active = document.querySelector('#wkTabs .wk-tab.is-active');
    build(active ? active.getAttribute('data-filter') : 'all');
    refreshAuto();
  }
  if ('IntersectionObserver' in window) {
    var nearIo = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      nearIo.disconnect();
      firstBuild();
    }, { rootMargin: '600px 0px' });
    nearIo.observe(track);
  } else {
    setTimeout(firstBuild, 100);
  }

})(); 





// (function () {
//   var track = document.getElementById('wkTrack');
//   if (!track) return;

//   var prev = document.getElementById('wkPrev');
//   var next = document.getElementById('wkNext');
//   var dots = document.getElementById('wkDots');
//   var tabs = [].slice.call(document.querySelectorAll('#wkTabs .wk-tab'));

//   var isGrid = track.classList.contains('wk-grid');
//   var GAP = 24;
//   var originals = [].slice.call(track.querySelectorAll('.wk-card'));
//   var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

//   var shown = originals.slice();
//   var cycle = 0, pages = 1, timer = null, target = null, idle = 0;
//   var down = false, moved = false, startX = 0, startLeft = 0;
//   var TICK = 30;
//   var HOLD = Math.round(4500 / TICK);

//   function normalizeTag(value) {
//     return (value || "").toString().trim().toLowerCase();
//   }

//   /* LOCALE FIX: on a translated storefront the URL is /ar/pages/portfolio while
//      the menu link may be /pages/portfolio (or the other way round). Strip the
//      locale root from both sides before comparing. */
//   function stripLocale(path) {
//     var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
//     root = root.replace(/\/+$/, '');
//     if (root && path.indexOf(root) === 0 &&
//         (path.length === root.length || path.charAt(root.length) === '/')) {
//       path = path.slice(root.length);
//     }
//     return path.replace(/\/+$/, '');
//   }

//   /* Compare a menu link's path to the current page exactly, with and without
//      the locale prefix. */
//   function samePath(link, currentPath) {
//     var href = link.getAttribute("href");
//     if (!href || href.charAt(0) === "#") return false;
//     var path;
//     try { path = new URL(href, window.location.origin).pathname; } catch (e) { return false; }
//     path = path.replace(/\/+$/, "");
//     if (path === "") return false;
//     if (path === currentPath) return true;
//     var a = stripLocale(path), b = stripLocale(currentPath);
//     return a !== "" && a === b;
//   }

//   /* Returns:
//        "tag-a,tag-b"  the current page's menu link carries tags
//        ""             the current page's menu link has data-portfolio-tag but it
//                       is empty -> all cards are hidden
//        null           no menu link for this page carries the attribute -> all
//                       cards are hidden */
//   function getActiveMenuTag() {
//     var currentPath = window.location.pathname.replace(/\/+$/, "");
//     function isCurrent(link) {
//       return link.getAttribute("aria-current") === "page" || samePath(link, currentPath);
//     }

//     /* Only the page's own link counts. A sub-link without the attribute does
//        NOT inherit its group heading's tag, so the section stays hidden. */
//     var found = false;
//     var tagged = document.querySelectorAll("a[data-portfolio-tag]");
//     for (var i = 0; i < tagged.length; i++) {
//       if (!isCurrent(tagged[i])) continue;
//       found = true;
//       var tag = tagged[i].getAttribute("data-portfolio-tag").trim();
//       if (tag) return normalizeTag(tag);
//     }

//     return found ? "" : null;
//   }

//   /* Only sections that opt in (data-menu-filter on #wkTrack, set in
//      work-grid.liquid) filter by the header tag. Others, like the homepage
//      n-work-grid, always show every card. */
//   var menuFilter = track.hasAttribute('data-menu-filter');

//   /* Every key a card can be matched on: tag handles and handleized names
//      (data-tags-name, comma separated), handles (data-tags, space separated)
//      and the visible labels (data-tags-label, | separated). Handles are never
//      translated, so they keep working on every locale. */
//   function cardKeys(card) {
//     var keys = [];
//     (card.getAttribute("data-tags-name") || "").split(",").forEach(function (t) { keys.push(normalizeTag(t)); });
//     (card.getAttribute("data-tags") || "").split(/\s+/).forEach(function (t) { keys.push(normalizeTag(t)); });
//     (card.getAttribute("data-tags-label") || "").split("|").forEach(function (t) { keys.push(normalizeTag(t)); });
//     return keys.filter(Boolean);
//   }

//   function rawMenuMatch(card, menuTag) {
//     var keys = cardKeys(card);
//     var menuTagsArray = menuTag.split(",").map(function (t) { return normalizeTag(t); }).filter(Boolean);
//     return menuTagsArray.some(function (mTag) {
//       return keys.indexOf(mTag) !== -1;
//     });
//   }

//   /* FAIL OPEN: the server (work-grid-card.liquid) already filters cards by the
//      page's portfolio_tag metafield, so this menu filter is only a second layer.
//      If there is no tagged menu link for this page, or the tag matches none of
//      the cards (e.g. a translated menu tag), show the cards instead of hiding
//      every one of them. */
//   var menuMatchCache = {};
//   function anyCardMatchesMenu(menuTag) {
//     if (!(menuTag in menuMatchCache)) {
//       menuMatchCache[menuTag] = originals.some(function (c) { return rawMenuMatch(c, menuTag); });
//     }
//     return menuMatchCache[menuTag];
//   }

//   function cardMatchesMenuTag(card, menuTag) {
//     if (!menuFilter) return true;
//     if (!menuTag) return true;                       // no tagged link / empty tag: do not hide
//     if (!anyCardMatchesMenu(menuTag)) return true;   // tag matches nothing: do not hide
//     return rawMenuMatch(card, menuTag);
//   }

//   function cardMatchesTabFilter(card, tabFilter) {
//     if (tabFilter === 'all') return true;
//     if (card.getAttribute('data-type') === tabFilter) return true;
//     var tagsSpace = card.getAttribute('data-tags');
//     if (tagsSpace && (' ' + tagsSpace + ' ').indexOf(' ' + tabFilter + ' ') !== -1) return true;
//     var tagsName = card.getAttribute('data-tags-name');
//     if (tagsName) {
//       var tagsArray = tagsName.split(',').map(function (t) { return normalizeTag(t); });
//       if (tagsArray.indexOf(normalizeTag(tabFilter)) !== -1) return true;
//     }
//     return false;
//   }

//   /* Cards only show for this page's mega-menu data-portfolio-tag. With no tagged
//      link for this page or an empty tag, every card is hidden (the section stays).
//      Tabs with no cards for this page's tag would lead to an empty view. */
//   var pageMenuTag = getActiveMenuTag();

//   /* Debug helper: type  wkDebug()  in the console on a page where cards vanish. */
//   window.wkDebug = function () {
//     var tagged = [].slice.call(document.querySelectorAll("a[data-portfolio-tag]")).map(function (a) {
//       return { href: a.getAttribute("href"), tag: a.getAttribute("data-portfolio-tag"), current: a.getAttribute("aria-current") };
//     });
//     return {
//       path: window.location.pathname,
//       shopifyRoot: window.Shopify && Shopify.routes && Shopify.routes.root,
//       menuFilter: menuFilter,
//       activeMenuTag: getActiveMenuTag(),
//       taggedMenuLinks: tagged,
//       cards: originals.map(function (c) { return cardKeys(c); })
//     };
//   };

//   tabs = tabs.filter(function (tab) {
//     var filter = tab.getAttribute('data-filter');
//     if (filter === 'all') return true;
//     var has = originals.some(function (c) {
//       return cardMatchesMenuTag(c, pageMenuTag) && cardMatchesTabFilter(c, filter);
//     });
//     if (!has) tab.hidden = true;
//     return has;
//   });

//   if (isGrid) {
//     function applyGridFilter() {
//       var activeMenuTag = getActiveMenuTag();
//       var activeTabBtn = document.querySelector('#wkTabs .wk-tab.is-active');
//       var activeTabFilter = activeTabBtn ? activeTabBtn.getAttribute('data-filter') : 'all';

//       originals.forEach(function (card) {
//         var matchesTab = (activeTabFilter === 'all') || cardMatchesTabFilter(card, activeTabFilter);
//         var matchesMenu = cardMatchesMenuTag(card, activeMenuTag);
//         if (matchesTab && matchesMenu) {
//           card.classList.remove('hidden');
//           card.hidden = false;
//         } else {
//           card.classList.add('hidden');
//           card.hidden = true;
//         }
//       });

//       if (tabs) {
//         tabs.forEach(function (tab) {
//           var filter = tab.getAttribute('data-filter');
//           var count = 0;
//           originals.forEach(function (card) {
//             if (cardMatchesMenuTag(card, activeMenuTag) && cardMatchesTabFilter(card, filter)) count++;
//           });
//           var span = tab.querySelector('span');
//           if (span) span.textContent = count;
//         });
//       }
//     }

//     tabs.forEach(function (tab) {
//       tab.addEventListener('click', function () {
//         tabs.forEach(function (t) {
//           var on = t === tab;
//           t.classList.toggle('is-active', on);
//           t.setAttribute('aria-selected', on ? 'true' : 'false');
//         });
//         applyGridFilter();
//       });
//     });

//     setTimeout(applyGridFilter, 100);
//     return;
//   }

//   /* Cached geometry — see the matching note in sliders.js. cardWidth and
//      frameWidth were measured from the DOM on every tick via sync() -> stride()
//      -> perView(), and isRTL ran getComputedStyle on every scroll write. At the
//      33 Hz creep that is several forced layouts a tick; Lighthouse attributed
//      2,210 ms of mobile CPU to this file. None of it changes between frames. */
//   var mCard = null, mFrame = null;
//   function invalidateMeasures() { mCard = mFrame = null; }

//   function cardWidth() {
//     if (mCard === null) {
//       var c = track.querySelector('.wk-card');
//       mCard = c ? c.getBoundingClientRect().width : 0;
//     }
//     return mCard;
//   }

//   function frameWidth() {
//     if (mFrame === null) {
//       var c = track.closest('.container');
//       mFrame = c ? c.clientWidth : track.clientWidth;
//     }
//     return mFrame;
//   }

//   function perView() {
//     var w = cardWidth();
//     if (!w) return 1;
//     return Math.max(1, Math.floor((frameWidth() + GAP) / (w + GAP)));
//   }

//   function stride() { return perView() * (cardWidth() + GAP); }
//   var rtl = getComputedStyle(track).direction === 'rtl';
//   function sx() { return Math.abs(track.scrollLeft); }
//   function setSx(v) { track.scrollLeft = rtl ? -v : v; }
//   function addSx(d) { setSx(sx() + d); }

//   function updateCounts() {
//     if (!tabs) return;
//     var activeMenuTag = getActiveMenuTag();

//     tabs.forEach(function (tab) {
//       var filter = tab.getAttribute('data-filter');
//       var count = 0;
//       originals.forEach(function (card) {
//         if (cardMatchesMenuTag(card, activeMenuTag) && cardMatchesTabFilter(card, filter)) count++;
//       });
//       var span = tab.querySelector('span');
//       if (span) span.textContent = count;
//     });
//   }

//   function build(filter) {
//     var activeMenuTag = getActiveMenuTag();
//     shown = originals.filter(function (c) {
//       return ((filter === 'all') || cardMatchesTabFilter(c, filter)) && cardMatchesMenuTag(c, activeMenuTag);
//     });

//     while (track.firstChild) track.removeChild(track.firstChild);
//     shown.forEach(function (c) { track.appendChild(c); });

//     // If there are 2 or fewer slides, hide the arrows and dots and stop the creep.
//     if (shown.length <= 2) {
//       if (prev) prev.style.display = 'none';
//       if (next) next.style.display = 'none';
//       if (dots) {
//         dots.style.display = 'none';
//         dots.innerHTML = '';
//       }
//       if (timer) { clearInterval(timer); timer = null; }
//       cycle = 0;
//       setSx(0);
//       target = null;
//       updateCounts();
//       return;
//     }

//     if (prev) prev.style.display = '';
//     if (next) next.style.display = '';
//     if (dots) dots.style.display = '';

//     cycle = shown.length * (cardWidth() + GAP);
//     if (cycle > 0) {
//       var need = cycle * 2 + track.clientWidth;
//       var total = cycle;
//       while (total < need) {
//         shown.forEach(function (c) {
//           var clone = c.cloneNode(true);
//           clone.setAttribute('aria-hidden', 'true');
//           clone.setAttribute('tabindex', '-1');
//           // Links and buttons inside a hidden copy must not be reachable with Tab either.
//           Array.prototype.forEach.call(clone.querySelectorAll('a[href], button, input, select, textarea, iframe, summary, [tabindex]'), function (n) {
//             n.setAttribute('tabindex', '-1');
//           });
//           track.appendChild(clone);
//         });
//         total += cycle;
//       }
//     }

//     setSx(0);
//     target = null;
//     buildDots();
//     sync();
//     updateCounts();
//   }

//   function loop() {
//     if (cycle <= 0) return;
//     if (sx() >= cycle * 2) {
//       addSx(-cycle);
//       if (target !== null) target -= cycle;
//     }
//   }

//   function buildDots() {
//     if (!dots) return;

//     pages = Math.max(1, Math.ceil(shown.length / perView()));
//     dots.innerHTML = '';

//     // The <= 2 case returned above, so dots are always shown here
//     dots.style.display = 'flex';
//     for (var i = 0; i < pages; i++) {
//       var d = document.createElement('button');
//       d.type = 'button';
//       d.className = 'slider-dot';
//       d.setAttribute('data-i', i);
//       d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
//       dots.appendChild(d);
//     }
//     /* Clicks are delegated to #wkDots (bound once, below) instead of one
//        listener per dot: the dots are rebuilt on every filter change and every
//        resize, which used to stack duplicate handlers. */
//     setActiveDot(pageFromPos(target !== null ? target : sx()));
//   }

//   /* Which page is on screen. The position can sit anywhere inside the cloned
//      loop, so fold it back into one cycle, round to the nearest page and wrap.
//      The result is always 0..pages-1, so exactly one dot can ever be active. */
//   function pageFromPos(pos) {
//     if (cycle <= 0) return 0;
//     var s = stride();
//     if (!s) return 0;
//     var within = ((pos % cycle) + cycle) % cycle;
//     return ((Math.round(within / s) % pages) + pages) % pages;
//   }

//   /* Keep the active dot inside the strip. There is one dot per page, so the row
//      is often wider than the section. Does nothing when the whole row fits. */
//   function keepDotInView(el) {
//     if (!dots || !el) return;
//     var max = dots.scrollWidth - dots.clientWidth;
//     if (max <= 1) return;
//     var strip = dots.getBoundingClientRect();
//     var dot = el.getBoundingClientRect();
//     var want = dots.scrollLeft + (dot.left - strip.left) - (dots.clientWidth - dot.width) / 2;
//     want = rtl ? Math.min(0, Math.max(-max, want)) : Math.max(0, Math.min(max, want));
//     if (Math.abs(dots.scrollLeft - want) < 1) return;
//     if (dots.scrollTo) dots.scrollTo({ left: want, behavior: calm.matches ? 'auto' : 'smooth' });
//     else dots.scrollLeft = want;
//   }

//   function setActiveDot(idx) {
//     if (!dots) return;
//     var kids = dots.children;
//     for (var j = 0; j < kids.length; j++) {
//       var on = j === idx;
//       // Only write when the state actually changes: sync() runs on every scroll
//       // event and on every animation tick.
//       if (kids[j].classList.contains('active') === on) continue;
//       kids[j].classList.toggle('active', on);
//       if (on) {
//         kids[j].setAttribute('aria-current', 'true');
//         keepDotInView(kids[j]);
//       } else {
//         kids[j].removeAttribute('aria-current');
//       }
//     }
//   }

//   /* While a glide is running the dots follow its destination; otherwise they
//      follow the real scroll position. One code path, so the dots cannot disagree
//      with the slides. */
//   function sync() {
//     if (!dots || !dots.children.length || cycle <= 0) return;
//     setActiveDot(pageFromPos(target !== null ? target : sx()));
//   }

//   function glideTo(to) {
//     if (calm.matches) { setSx(to); loop(); sync(); return; }
//     target = to;
//     sync();
//   }

//   if (dots) {
//     dots.addEventListener('click', function (e) {
//       var btn = e.target && e.target.closest ? e.target.closest('.slider-dot') : null;
//       if (!btn || !dots.contains(btn)) return;
//       var idx = parseInt(btn.getAttribute('data-i'), 10);
//       if (isNaN(idx)) return;
//       var base = cycle > 0 ? Math.floor(sx() / cycle) * cycle : 0;
//       glideTo(base + idx * stride());
//     });
//   }

//   function step(dir) {
//     var amount = Math.max(cardWidth() + GAP, track.clientWidth * 0.6);
//     var from = target !== null ? target : sx();
//     if (dir < 0 && from < amount) { addSx(cycle); from += cycle; }
//     glideTo(from + dir * amount);
//   }

//   function tick() {
//     if (down) return;
//     if (target !== null) {
//       var d = target - sx();
//       if (Math.abs(d) < 1.5) { setSx(target); target = null; idle = HOLD; }
//       else { addSx(d * 0.16); }
//       loop(); sync(); return;
//     }
//     if (idle > 0) { idle--; return; }
//     if (hovered) return;
//     addSx(1); loop();
//   }

//   /* :hover was matched on every tick, forcing a style recalc; two listeners
//      carry the same state for nothing. The creep only runs while the strip is
//      visible and the tab is in the foreground. */
//   var hovered = false;
//   track.addEventListener('mouseenter', function () { hovered = true; });
//   track.addEventListener('mouseleave', function () { hovered = false; });

//   var onScreen = true;
//   function refreshAuto() {
//     if (onScreen && !document.hidden) startAuto(); else stopAuto();
//   }
//   if ('IntersectionObserver' in window) {
//     new IntersectionObserver(function (entries) {
//       onScreen = entries[0].isIntersecting;
//       refreshAuto();
//     }, { threshold: 0 }).observe(track);
//   }
//   document.addEventListener('visibilitychange', refreshAuto);

//   function startAuto() {
//     if (timer || calm.matches || cycle <= 0) return;
//     timer = setInterval(tick, TICK);
//   }

//   function stopAuto() {
//     if (timer) { clearInterval(timer); timer = null; }
//   }

//   if (prev) prev.addEventListener('click', function () { step(-1); });
//   if (next) next.addEventListener('click', function () { step(1); });

//   track.addEventListener('keydown', function (e) {
//     if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
//     if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
//   });

//   track.addEventListener('scroll', function () { loop(); sync(); }, { passive: true });

//   track.addEventListener('mousedown', function (e) {
//     if (e.button !== 0) return;
//     down = true; moved = false; startX = e.pageX; startLeft = sx(); target = null;
//   });

//   window.addEventListener('mousemove', function (e) {
//     if (!down) return;
//     var dx = (e.pageX - startX) * (rtl ? -1 : 1);
//     if (Math.abs(dx) > 6) { moved = true; track.classList.add('dragging'); }
//     if (moved) {
//       e.preventDefault();
//       var left = startLeft - dx;
//       if (cycle > 0) {
//         while (left < 0) left += cycle;
//         while (left >= cycle * 2) left -= cycle;
//       }
//       setSx(left);
//       sync();
//     }
//   });

//   window.addEventListener('mouseup', function () {
//     if (!down) return;
//     down = false; idle = HOLD;
//     setTimeout(function () { track.classList.remove('dragging'); moved = false; }, 50);
//   });

//   track.addEventListener('click', function (e) {
//     if (moved || track.classList.contains('dragging')) { e.preventDefault(); e.stopPropagation(); }
//   }, true);

//   tabs.forEach(function (tab) {
//     tab.addEventListener('click', function () {
//       tabs.forEach(function (t) {
//         var on = t === tab;
//         t.classList.toggle('is-active', on);
//         t.setAttribute('aria-selected', on ? 'true' : 'false');
//       });
//       built = true;
//       invalidateMeasures();
//       build(tab.getAttribute('data-filter'));
//       idle = HOLD;
//       refreshAuto();
//     });
//   });

//   var rt = null;
//   window.addEventListener('resize', function () {
//     invalidateMeasures();
//     clearTimeout(rt);
//     rt = setTimeout(function () {
//       if (!built) return;
//       invalidateMeasures();
//       rtl = getComputedStyle(track).direction === 'rtl';
//       var active = document.querySelector('#wkTabs .wk-tab.is-active');
//       build(active ? active.getAttribute('data-filter') : 'all');
//       refreshAuto();
//     }, 200);
//   });

//   /* The first build (filter + clone the cards for the seamless loop) runs when
//      the strip comes within ~600px of the viewport instead of 100ms after load.
//      Cloning and measuring the cards during load produced the forced reflows and
//      most of the extra DOM Lighthouse reported; the section is below the fold,
//      so the visitor never sees the difference. */
//   var built = false;
//   function firstBuild() {
//     if (built) return;
//     built = true;
//     invalidateMeasures();
//     var active = document.querySelector('#wkTabs .wk-tab.is-active');
//     build(active ? active.getAttribute('data-filter') : 'all');
//     refreshAuto();
//   }
//   if ('IntersectionObserver' in window) {
//     var nearIo = new IntersectionObserver(function (entries) {
//       if (!entries[0].isIntersecting) return;
//       nearIo.disconnect();
//       firstBuild();
//     }, { rootMargin: '600px 0px' });
//     nearIo.observe(track);
//   } else {
//     setTimeout(firstBuild, 100);
//   }

// })();
